import { drawRaster, rasterWidth, rasterHeight } from '@/engine/canvas';
import { UI_W, UI_H } from '@/engine/canvas';

export const FONT = '16px NeoDGM';

export function text(ctx: CanvasRenderingContext2D, s: string, x: number, y: number, color = '#f4f0e6', align: CanvasTextAlign = 'left', shadow = true): void {
  ctx.font = FONT;
  ctx.textAlign = align;
  ctx.textBaseline = 'top';
  if (shadow) {
    ctx.fillStyle = 'rgba(0,0,0,0.85)';
    ctx.fillText(s, x + 2, y + 2);
  }
  ctx.fillStyle = color;
  ctx.fillText(s, x, y);
}

export function textWidth(ctx: CanvasRenderingContext2D, s: string): number {
  ctx.font = FONT;
  return ctx.measureText(s).width;
}

export function panel(ctx: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, fill = 'rgba(8,6,14,0.82)', border = '#6a5a7a'): void {
  ctx.fillStyle = fill;
  ctx.fillRect(x, y, w, h);
  ctx.strokeStyle = border;
  ctx.lineWidth = 2;
  ctx.strokeRect(x + 1, y + 1, w - 2, h - 2);
}

export function bar(ctx: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, v: number, color: string, bg = '#1a1420'): void {
  ctx.fillStyle = bg;
  ctx.fillRect(x, y, w, h);
  ctx.fillStyle = color;
  ctx.fillRect(x + 2, y + 2, Math.round((w - 4) * Math.max(0, Math.min(1, v))), h - 4);
}

/** word-wrap by measuring; returns lines */
export function wrap(ctx: CanvasRenderingContext2D, s: string, maxW: number): string[] {
  ctx.font = FONT;
  const out: string[] = [];
  for (const para of s.split('\n')) {
    let line = '';
    for (const ch of para) {
      const test = line + ch;
      if (ctx.measureText(test).width > maxW && line.length > 0) {
        out.push(line);
        line = ch === ' ' ? '' : ch;
      } else line = test;
    }
    out.push(line);
  }
  return out;
}

export function dimScreen(ctx: CanvasRenderingContext2D, a = 0.6): void {
  ctx.fillStyle = `rgba(0,0,0,${a})`;
  ctx.fillRect(0, 0, UI_W, UI_H);
}

export function drawScaled(ctx: CanvasRenderingContext2D, img: HTMLCanvasElement, x: number, y: number, scale: number): void {
  ctx.imageSmoothingEnabled = false;
  drawRaster(ctx, img, x, y, rasterWidth(img) * scale, rasterHeight(img) * scale);
}
